<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Etkinlik Listesi
            </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-actions">
                <a routerLink="/event-list/new" class="btn btn-success btn-pill btn-sm">
                    <i class="fa fa-plus marr10"></i>Yeni Ekle
                </a>

            </div>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Etkinlik ismi</th>
                                <th>Mekan</th>
                                <th>Durum</th>
                                <th>Başlangıç tarihi</th>
                                <th>Bitiş tarihi</th>
                                <th>Son başvuru tarihi</th>
                                <th>Herkese açık mı?</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let event of events;">
                                <td>{{event.name}}</td>
                                <td>{{event.location}}</td>
                                <td>{{getStatus(event.status)}}</td>
                                <td>{{event.startDate}}</td>
                                <td>{{event.endDate}}</td>
                                <td>{{event.applicationEndDate === null ? "-" : event.applicationEndDate}}</td>
                                <td>{{getAvailability(event.isAvailableAllUser)}}</td>
                                <td>
                                    <button class="btn btn-primary mr-2" [routerLink]="['/application-list/'+event.id]"><i
                                        class="fa fa-list"></i>Başvurular</button>
                                    <button class="btn btn-warning mr-2" [routerLink]="['/event-property-list/'+event.id]"><i
                                        class="fa fa-tasks"></i>Etkinlik rolleri</button>
                                    <button class="btn btn-success mr-2"
                                        [routerLink]="['/event-list/detail/'+event.id]"><i
                                        class="fa fa-edit"></i>Düzenle</button>
                                    <button class="btn btn-danger mr-2" (click)="deleteEvent(event.id, event.name)"><i
                                            class="fa fa-trash"></i>Sil</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
